<template>
   <div v-if="loading" class="spinner-container">
      <div class="spinner"></div>
    </div>
    <div v-else>
          <!-- Keep-alive should wrap <router-view /> -->
         
    <div class="homepage d-flex flex-column vh-100">
         <!-- navbar -->
         <div class="homepage-navbar bg-light shadow mb-auto p-3 bg-primary">
            <div class="d-flex align-items-center">
         
                   <span @click="goBack()" class="text-white"><i class="bi bi-arrow-left fs-5"></i></span> &nbsp; &nbsp;
                  <span>
                     <h4 class="text-white">{{language?.service_name}}</h4>
                  </span>
         
            
               <div class="d-flex align-items-center gap-2 ms-auto">
                
                 <a href="#" class="link-dark text-truncate d-flex align-items-center gap-2" data-bs-toggle="offcanvas" data-bs-target="#service"
                  aria-controls="service">
                  <b class="bg-dark bg-opacity-75 rounded-circle user-icon">
                  <i class="bi bi-plus d-flex m-0 h4 text-white"></i>
                  </b>
                  </a>
               </div>
            </div>
            



         </div>
    
         <!-- body -->
         <div class="my-auto overflow-auto vh-100">
           
            <!-- Top Evets -->
            <div class="pt-3 bg_card">
               
               <div class="row">
                  <!-- 1st item -->
                  <div class="">
                    <h5 v-if="services && services.length==0" class="text-center">No Services, Please Add New</h5>
                     <div class="card  border-1 overflow-hidden " v-for="(service,i) in services">
                        
                                <div class="card-body">


                                 <div class="row g-2">


                           <div class="col-auto" v-if="userRow.image_upload == 1">
                                    <img
                                      :src="'https://laundry.dktsoft.in/public/uploads/serviceimg/' + service.serviceimage"
                                      style="width:45px;height:45px;object-fit:cover;"
                                    >
                                  </div>

                                    <div class="col ps-1">   

                                   <div> <i class="bi bi-caret-right-square-fill "></i>  {{service.name}}</div>
                                   <div> {{service.description}}</div>

                                   </div>


                                    </div>



                                </div> 
                            
                        <div
                           class="card-footer ">
                           <div>
                              <span class="badge bg-success" @click="editService(service)"><i class="bi bi-pen"></i> &nbsp;{{language?.edit}}</span> &nbsp; &nbsp; 
                              <span class="badge bg-danger" @click="deleteService(service.id)"><i class="bi bi-trash"></i> &nbsp; {{language?.delete}}</span>
                           </div>
                            
                        </div>

                     </div> 
                  </div> 
                  
               </div> 
            </div>

       


 


  
         </div>
         
         <div class="offcanvas offcanvas-end border-0" tabindex="-1" id="service" aria-labelledby="branchLabel">
         <div class="offcanvas-header bg-primary d-flex align-items-center justify-content-start gap-3">
            <a href="#" data-bs-dismiss="offcanvas" aria-label="Close"><i class="bi bi-arrow-left fs-5 text-white"></i></a>
            <h6 class="offcanvas-title text-white m-0" id="branchLabel">{{language?.create_new_service}}</h6>
         </div>
         <div class="offcanvas-body">


           
                <div class="mb-3" v-if="userRow.image_upload == 1">
                    <label  class="form-label" for="img_upload_here">{{language?.Image}}<br>
                    <input type="file" id="img_upload_here" style="display: none;" @change="eventFileUpload" class="form-control" required>
                    <!-- <img src="../assets/upload_image.jpg" style="             height: 50px; "/> -->
                    <img v-if="imagePreview" :src="imagePreview" style="max-width: 150px; border: 2px solid #000; border-radius: 5px;">
                    </label>
                </div>
                
                    <div class="mb-3">
                        <label for="name" class="form-label">{{language?.services_name}}</label>
                        <input type="text" id="name" v-model="service.name" class="form-control" required>
                    </div>

                    <div class="mb-3">
                     <label for="description" class="form-label">{{language?.services_description}}</label>
                     <input type="text" id="description" v-model="service.description" class="form-control" required>
                 </div>
                    <div class="d-flex gap-2">
                    <button class="btn btn-primary w-100 " @click="addService">{{language?.save}}</button>
                    <button class="btn btn-secondary w-50" @click="goprevious">{{language?.back}}</button>
                    </div>
                 
         </div>
      </div>
      </div>
    </div>
</template>
  
<script> 
import axios from "@/plugins/axios";  

export default {
  name: 'Branch',
  components: { 
  },
  mounted() { 
   //  this.fetchWeather();
    this.addServices(); // Call the method here
    
},
  data() {
    return { 
      imagePreview:'',
      loading:false,
      error:null,
      isUserLogged:false,
      user_details:[],
      language:this.getLocalStorageArray('lang'),
      service:{
         name:'',
         description:'',
         serviceimage:'',
      },
      services:[], 
      userRow:[],
      branch_name:''

    }
  },
  methods:{
    initializeHomeContent(){
    

    }
,
 

 
    goBack() {
          
                this.$router.go(-1);
        },

        goprevious() {
          
          this.$router.go("/services");
  },


    async addServices() {
        this.loading = true;
        this.error = null;
  
        try {
           var self=this;
            axios.post("getservices").then((response) => {
               self.services=response.data.service;
               self.userRow=response.data.userRow;
               self.language=response.data.language;
               localStorage.setItem('lang',response.data.language);
        
          }).then(() => {
               self.initializeHomeContent();
          }).catch((err) => {
            
          });;
         

        } catch (err) {
          this.error = err.response?.data?.message || "Login failed. Please try again.";
        } finally {
          this.loading = false;
        }
      }, 





       addService() {
        this.loading = true;
        this.error = null;
  
        try {
           var self=this;
            axios.post("addService",self.service,


          {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
          }


            ).then((response) => {
              
                     self.services=response.data.service
                     self.userRow=response.data.userRow
                     self.$swal.fire(response.data.message);
                     if(response.data.success)
                     {
                        self.service={ name:'',description:''};
                     }
                     window.bootstrap.Offcanvas.getOrCreateInstance(document.getElementById("service")).hide();
                      

               
        
          }).then(() => {
               self.initializeHomeContent();
          }).catch((err) => {
            
          });;
         

        } catch (err) {
          this.error = err.response?.data?.message || "Login failed. Please try again.";
        } finally {
          this.loading = false;
        }
      }, 


      editService(editService) {
         window.bootstrap.Offcanvas.getOrCreateInstance(document.getElementById("service")).show();
         this.service=editService;
      }, 





      deleteService(id = "") {
    this.loading = true;
    this.error = null;

    try {
        var self = this;

        this.$swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "No, cancel",
        }).then((result) => {
            if (result.isConfirmed) {
                axios.post("deleteService", { id: id }).then((response) => {

                    self.services=response.data.service;
                    self.$swal.fire(response.data.message);
                    
                    if (response.data.success) {
                        window.bootstrap.Offcanvas.getOrCreateInstance(document.getElementById("branch")).hide();
                    }
                }).then(() => {
                  //   self.initializeHomeContent();
                }).catch((err) => {
                  console.log(err);
                  //   self.$swal.fire("Error!", "Something went wrong.", "error");
                });
            }
        });

    } catch (err) {
        this.error = err.response?.data?.message || "Login failed. Please try again.";
    } finally {
        this.loading = false;
    }
},




getLocalStorageArray(key) {
        let data = localStorage?.getItem(key);
        try {
            return data ? JSON.parse(data) : [];
        } catch (e) {
            console.error("Error parsing localStorage data", e);
            return [];
        }
    },
         eventFileUpload(event) {
                this.service.serviceimage = event.target.files[0]; // Store the selected file
                const file = event.target.files[0]; // Correctly define 'file'
                    if (file) {
                      this.service.serviceimage = file; // Store the selected file
                      this.imagePreview = URL.createObjectURL(file); // Create image preview
                    }
            },















  }
}






</script>
